<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.back()">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="0"></bg>
      <ion-grid>
        <headerlogo></headerlogo>
        <form @submit="save">
          <ion-row class="row-boxed">
            <ion-col size-xs="12" size-md="6">
              <ion-input placeholder="Name" :value="user.name" @ionInput="user.name = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input placeholder="Last name" :value="user.last_name" @ionInput="user.last_name = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input placeholder="Email" :value="user.email" disabled></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input placeholder="Role" :value="user.company_role" @ionInput="user.company_role = $event.target.value;"></ion-input>
            </ion-col>
            <ion-col size-xs="12" size-md="6">
              <ion-input placeholder="Company or Riot" :value="user.company" @ionInput="user.company = $event.target.value;"></ion-input>
            </ion-col>
            <!-- <ion-col size-xs="12" size-md="6">
              <Select2 v-model="user.yachts" :options="yachts" :settings="{ multiple: true }" :placeholder="'Yacht'" />
            </ion-col> -->
            <ion-col size-xs="12" size-md="6">
              <ion-input placeholder="Admin / User / Client" :value="user.role" disabled></ion-input>
            </ion-col>
            <ion-col size="12" class="text-right">
              <ion-button type="submit">SAVE</ion-button>
            </ion-col>
          </ion-row>
          <!-- Permette l'invio del form con tasto enter -->
          <input type="submit" class="hidden">
        </form>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
export default {
  name: "Profile",
  data: function() {
    return {
      user: {},
      loader: true,
      yachts: []
    }
  },
  methods: {
    save(ev) {
      ev.preventDefault();
      this.loader = true;
      axios.post(this.apiUrl + '/api/v1/save-user', { api_token: this.$store.state.api_token, user: this.user })
      .then(async(response) => {
        let res = response.data
        if(res.data) {
          const toast = await this.$ionic.toastController.create({
            message: 'Profile updated succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
        this.loader = false;
      })
    }
  },
  mounted: async function() {
    await axios.post(this.apiUrl + '/api/v1/get-user', { api_token: this.$store.state.api_token })
    .then((response) => {
      let res = response.data
      if(res.data) {
        Vue.set(this.user, 'name', res.data.name);
        Vue.set(this.user, 'last_name', res.data.last_name);
        Vue.set(this.user, 'email', res.data.email);
        Vue.set(this.user, 'company_role', res.data.company_role);
        Vue.set(this.user, 'company', res.data.company);
        Vue.set(this.user, 'role', res.data.role);
        let yachts = res.data.yachts
        try {
          yachts = JSON.parse(yachts)
        } catch (error) {
          yachts = res.data.yachts
        }
        Vue.set(this.user, 'yachts', yachts);
      }
    })

    // await axios.post(this.apiUrl + '/api/v1/get-yachts', { api_token: this.$store.state.api_token })
    // .then((response) => {
    //   let res = response.data
    //   if(res.data.length) {
    //     let i = 0
    //     let obj = {
    //       id: 'all',
    //       text: 'All yachts'
    //     }
    //     this.yachts.push(obj)
    //     while (i < res.data.length) {
    //       let obj = {
    //         id: res.data[i].id,
    //         text: res.data[i].name
    //       }
    //       this.yachts.push(obj)
    //       i++
    //     }
    //   }
    // })

    this.loader = false;
}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>